// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lbNxw","col":"styles_col__2dKTL"};